import fragmentShader from "./shaders/pivotPoint.fs";
import vertexShader from "./shaders/pivotPoint.vs";

class PivotPointMaterial extends THREE.ShaderMaterial {
    constructor(parameters = {}) {
        const { getViewWidth } = parameters;

        let sizeAttenuation = 'sizeAttenuation' in parameters ? Boolean(parameters.sizeAttenuation) : true;

        const defines = {
            SIZE_ATTENUATION: Number(sizeAttenuation),
        };
        const uniforms = {
            color: { value: new THREE.Color(0.9, 0, 0) },
            colorOutline: { value: new THREE.Color(1, 1, 1) },
            opacity: { value: 1 },
            size: Object.defineProperty({}, 'value', {
                configurable: true,
                enumerable: true,
                get: () => this._size*(this._sizeAttenuation ? getViewWidth() : 1),
            }),
        };

        super({
            uniforms,
            defines,
            fragmentShader,
            vertexShader,
            depthTest: false,
            depthWrite: false,
        });

        this._size = 'size' in parameters ? parameters.size : 1;
        this._sizeAttenuation = sizeAttenuation;
    }

    get size() {
        return this._size;
    }

    set size(value) {
        this._size = value;
    }

    get sizeAttenuation() {
        return this._sizeAttenuation;
    }

    set sizeAttenuation(value) {
        value = Boolean(value);
        if (value === this._sizeAttenuation) return;

        this._sizeAttenuation = sizeAttenuation;
        this.defines.SIZE_ATTENUATION = sizeAttenuation;
        this.needsUpdate = true;
    }
}

export default PivotPointMaterial;
export { PivotPointMaterial };